import { css } from 'styled-components';

interface INavItem {
  active?: boolean;
}

const activeStyles = css`
  color: ${({ theme }) => theme.colors.newKinedu};
  background-color: ${({ theme }) => theme.colors.newKineduLight};
  font-weight: bold;

  :hover {
    background-color: ${({ theme }) => theme.colors.newKineduLight};
  }

  svg * {
    fill: ${({ theme }) => theme.colors.newKinedu};
  }
`;

const MenuNavListItem = css`
  color: ${({ theme }) => theme.colors.shadeDark};
  border-bottom-color: ${({ theme }) => theme.colors.shadeMediumLight};
  transition: 0.5s;

  svg * {
    fill: ${({ theme }) => theme.colors.shadeDark};
  }

  ${({ active }: INavItem) => active && activeStyles}
`;

export default MenuNavListItem;
